<ng-container [formGroup]="formGroup">
  <div class="row">
    <lc-textbox class="col" formControlName="title" label="Name" [idPrefix]="idPrefix + '-title'" />
  </div>
  <div class="row">
    <lc-textbox class="col" formControlName="uri" label="Link" [idPrefix]="idPrefix + '-link'" />
  </div>
</ng-container>
